require('./ProgramPersons.scss');

const b = require('app/www/libs/b')('program-persons');

const sliceString = require('app/common/libs/sliceString');

const React = require('react');
const PropTypes = require('prop-types');

const {withI18n} = require('app/www/components/contexts/I18n');

const Global = require('app/www/components/blocks/Global/Global');
const Link = require('app/www/components/blocks/Link/Link');
const ProgramSubtitle = require('app/www/components/blocks/ProgramSubtitle/ProgramSubtitle');
const Scroll = require('app/www/components/blocks/Scroll/Scroll');

const ACTOR = require('app/common/constants/roles')[3];
const ACTORS_COUNT = 5;

class ProgramPersons extends React.PureComponent {

    constructor(props) {
        super(props);

        const {persons} = this.props;

        this._actorsAll = persons.filter(person => person.image && person.role === ACTOR);
        this._actors = this._actorsAll.slice(0, ACTORS_COUNT);
    }

    render() {
        const {
            i18n,
            persons,
            isCartoon,
            programCoId,
            isLayoutColumnsSmall,
        } = this.props;

        const actors = isLayoutColumnsSmall ? this._actorsAll : this._actors;

        if (!actors.length) {
            return null;
        }

        const programSubtitleProps = {
            text: i18n.get(`program-persons.title-${isCartoon ? 'cartoon' : 'film'}`),
            link: persons.length > ACTORS_COUNT && {
                url: Global.kinopoiskProgramPersonsUrl(programCoId),
            },
        };

        const scrollProps = {
            touch: true,
        };

        const linkProps = {
            attrs: {
                target: '_blank',
                itemProp: ACTOR,
                itemType: 'http://schema.org/Person',
                itemScope: true,
            },
        };

        return (
            <div className={b()}>
                <div className={b('title')}>
                    <ProgramSubtitle {...programSubtitleProps} />
                </div>
                <Scroll {...scrollProps}>
                    {actors.map(actor => {
                        const url = Global.kinopoiskProgramPersonUrl(actor.id);

                        const imageStyle = {
                            backgroundImage: `url('${actor.image}')`,
                        };

                        const name = sliceString(actor.name);
                        const role = sliceString(actor.roleDetails);

                        return (
                            <Link
                                key={actor.name}
                                className={b('link')}
                                url={url}
                                {...linkProps}
                            >
                                <span className={b('image')} style={imageStyle} />
                                <span className={b('name')} itemProp="name">{name}</span>
                                <span className={b('role')}>{role}</span>
                            </Link>
                        );
                    })}
                </Scroll>
            </div>
        );
    }
}

ProgramPersons.propTypes = {
    persons: PropTypes.arrayOf(PropTypes.object),
    isCartoon: PropTypes.bool,
    programCoId: PropTypes.number,
    isLayoutColumnsSmall: PropTypes.bool,
};

module.exports = withI18n(ProgramPersons);
